import { configureStore } from '@reduxjs/toolkit'
import routeSelectionReducer from './components/routeSelection/RouteSelectionSlice'
import chartSettingsReducer from './components/chartSettings/ChartSettingsSlice'
import chartsReducer from './components/charts/ChartsSlice'
import authReducer, { setUser } from './components/auth/AuthSlice'
import feedbackReducer from './components/feedback/FeedbackSlice'
import { onAuthStateChanged } from "firebase/auth";
import { auth } from './firebase';
import _ from "lodash";

const store = configureStore({
  reducer: {
    routeSelection: routeSelectionReducer,
    chartSettings: chartSettingsReducer,
    charts: chartsReducer,
    auth: authReducer,
    feedback: feedbackReducer,
  },
})

// Initialize auth listener
onAuthStateChanged(auth, (authUser) => {
  if (authUser) {
    store.dispatch(setUser(_.pick(authUser, ["displayName", "email", "photoURL", "uid"])));
  } else {
    store.dispatch(setUser(null));
  }
});

export default store;